export default {
  path: '/lvy-back-to-single',
  component: () => import('./LVYBackToSingle'),
  meta: {
    title: '已脱单功能介绍',
    designWidth:750,
    expireIn: '',
    axiosConfig: {
      baseURL: '',
      withCredentials: false,
      postContentType: 'JSON'
    }
  }
}
